import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/page-client.tsx");
